


























import { Vue, Component } from "vue-property-decorator";
import * as InboxStore from "../store/modules/inbox";
import * as AuthStore from "../store/modules/auth";

@Component({})
export default class Layout extends Vue {
  get userId() {
    return InboxStore.getters.userId;
  }
  showSettings() {
    InboxStore.mutations.showSettings();
  }

  showNewMessage() {
    InboxStore.mutations.showNewMessage();
  }

  loadMessages() {
    InboxStore.actions.loadMessages();
  }

  logout() {
    AuthStore.actions.logout();
  }
}
